// extracted by mini-css-extract-plugin
module.exports = {"root":"PLADashboardWidgets_root__2O8ze"};